export const routes = {
  ROOT: '/',
};
